import { render } from "./SimRemittances.vue?vue&type=template&id=5d9c6cb6&scoped=true&ts=true"
import script from "./SimRemittances.vue?vue&type=script&lang=ts"
export * from "./SimRemittances.vue?vue&type=script&lang=ts"

import "./SimRemittances.vue?vue&type=style&index=0&id=5d9c6cb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9c6cb6"]])

export default __exports__